import { render } from "./Reports1CourseView.vue?vue&type=template&id=52440dc3&scoped=true"
import script from "./Reports1CourseView.vue?vue&type=script&lang=js"
export * from "./Reports1CourseView.vue?vue&type=script&lang=js"

import "./Reports1CourseView.vue?vue&type=style&index=0&id=52440dc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52440dc3"]])

export default __exports__